module.exports = __webpack_public_path__ + "img/1587008213.02d55da8.jpg";